export { default } from './BorrowingOptIn';



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingOptIn/index.js